/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The PatientsidgeneratePdfGeneratePdf model module.
 * @module model/PatientsidgeneratePdfGeneratePdf
 * @version v0.3
 */
export default class PatientsidgeneratePdfGeneratePdf {
  /**
   * Constructs a new <code>PatientsidgeneratePdfGeneratePdf</code>.
   * @alias module:model/PatientsidgeneratePdfGeneratePdf
   * @class
   * @param templateName {module:model/PatientsidgeneratePdfGeneratePdf.TemplateNameEnum} Please provide a valid template name. Valid template names are: [\"invoice\", \"superbill\"]
   * @param fromDate {String} Date from which to start the PDF report
   */
  constructor(templateName, fromDate) {
    this.templateName = templateName;
    this.fromDate = fromDate;
  }

  /**
   * Constructs a <code>PatientsidgeneratePdfGeneratePdf</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PatientsidgeneratePdfGeneratePdf} obj Optional instance to populate.
   * @return {module:model/PatientsidgeneratePdfGeneratePdf} The populated <code>PatientsidgeneratePdfGeneratePdf</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PatientsidgeneratePdfGeneratePdf();
      if (data.hasOwnProperty('template_name'))
        obj.templateName = ApiClient.convertToType(data['template_name'], 'String');
      if (data.hasOwnProperty('from_date'))
        obj.fromDate = ApiClient.convertToType(data['from_date'], 'String');
      if (data.hasOwnProperty('to_date'))
        obj.toDate = ApiClient.convertToType(data['to_date'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>templateName</code> property.
 * @enum {String}
 * @readonly
 */
PatientsidgeneratePdfGeneratePdf.TemplateNameEnum = {
  /**
   * value: "invoice"
   * @const
   */
  invoice: "invoice",

  /**
   * value: "superbill"
   * @const
   */
  superbill: "superbill"
};
/**
 * Please provide a valid template name. Valid template names are: [\"invoice\", \"superbill\"]
 * @member {module:model/PatientsidgeneratePdfGeneratePdf.TemplateNameEnum} templateName
 */
PatientsidgeneratePdfGeneratePdf.prototype.templateName = undefined;

/**
 * Date from which to start the PDF report
 * @member {String} fromDate
 */
PatientsidgeneratePdfGeneratePdf.prototype.fromDate = undefined;

/**
 * Date from which to end the PDF report
 * @member {String} toDate
 */
PatientsidgeneratePdfGeneratePdf.prototype.toDate = undefined;

